export const ORGANIZATION_LOGO_AND_ICON_MAX_SIZE = 400
